import React from 'react';
import { CalendarIcon } from '@heroicons/react/24/outline';
import IconSection from '../../../@communityshare/ui/card/IconSection';
import { formatDate, formatDateRange } from '../../../utils/dateTimeUtils';

export default function Date(props) {
  const { event } = props;

  if (event.data.specificDate === 'Yes') {
    return (
      <IconSection
        icon={CalendarIcon}
        title={formatDate(event.data.date)}
        tooltip="Date"
      />
    );
  }

  return (
    <IconSection
      icon={CalendarIcon}
      title={formatDateRange(event.data.startDate, event.data.endDate)}
      tooltip="Date"
    />
  );
}
